import {connect} from "react-redux";
import * as AuthActions from '../../store/actions/authActions';
import * as SidebarActions from "../../store/actions/sidebarActions";
import ContentHeader from "../../components/Common/ContentHeader";
import * as NotificationsActions from '../../store/actions/notificationsActions';
import * as TasksProgressActions from '../../store/actions/tasksProgressActions';
import * as VideoActions from '../../store/actions/videoActions';

const mapStateToProps = (state) => ({
    ...state.auth,
    ...state.video,
    ...state.notifications,
    ...state.tasksProgress
});

const mapDispatchToProps = (dispatch) => ({
    onLogout: () => {
        dispatch(VideoActions.clearState());
        dispatch(AuthActions.logoutUserAction());
    },
    onSidebarToggleCollapse: () => {
        dispatch(SidebarActions.toggleSidebarCollapsedAction());
    },
    onNotificationsLoad: () => {
        dispatch(NotificationsActions.getNotifications());
    },
    onTaskProgressLoad: () => {
        dispatch(TasksProgressActions.getTaskProgress());
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ContentHeader);


// WEBPACK FOOTER //
// ./src/containers/General/ContentHeaderContainer.js